(function () {
  'use strict';

  var TONES = {
    sand: '#f7f2e8', clay: '#eddccf', sage: '#e1e7d7',
    blue: '#dce8ee', lilac: '#e7dfec', rose: '#efdde2', ivory: '#f3efe8'
  };

  function galleryTone(pixels) {
    var scores = {}, visible = 0, colored = 0;
    for (var i = 0; i < pixels.length; i += 4) {
      if (pixels[i + 3] < 220) continue;
      visible++;
      var r = pixels[i] / 255, g = pixels[i + 1] / 255, b = pixels[i + 2] / 255;
      var hi = Math.max(r, g, b), lo = Math.min(r, g, b), delta = hi - lo;
      if (hi < .12 || lo > .94 || delta < .06) continue;
      var hue = hi === r ? (g - b) / delta : hi === g ? (b - r) / delta + 2 : (r - g) / delta + 4;
      hue = (hue * 60 + 360) % 360;
      var family = hue < 18 || hue >= 350 ? 'clay' : hue < 70 ? 'sand'
        : hue < 160 ? 'sage' : hue < 255 ? 'blue' : hue < 305 ? 'lilac' : 'rose';
      var weight = Math.pow(delta, 1.2);
      scores[family] = (scores[family] || 0) + weight;
      colored++;
    }
    if (!visible || colored / visible < .08) return TONES.ivory;
    var winner = Object.keys(scores).reduce(function (best, family) {
      return !best || scores[family] > scores[best] ? family : best;
    }, '');
    return TONES[winner] || TONES.ivory;
  }

  function initialize(gallery) {
    if (gallery.hasAttribute('data-gallery-tabs-ready')) return;
    var rail = gallery.querySelector('#pdp-thumbs');
    if (!rail) return;
    var previous = null;
    function syncLabels() {
      rail.querySelectorAll('.pdp-thumb').forEach(function (button) {
        var key = button.getAttribute('data-cle') || '';
        var item = button.closest('.pdp-thumb-item');
        var caption = item && item.querySelector('.pdp-thumb__cap');
        var label = caption ? caption.textContent.trim() : button.getAttribute('aria-label') || '';
        if (!button.hasAttribute('data-fixe') && !button.hasAttribute('data-mockup')) label = gallery.dataset.galleryLabelArt || label;
        if (key === 'zoom') label = gallery.dataset.galleryLabelDetail || label;
        if (button.hasAttribute('data-mockup') && key !== 'contexte') label = gallery.dataset.galleryLabelRoom || label;
        var text = button.querySelector('.pdp-thumb__label');
        if (!text) {
          text = document.createElement('span');
          text.className = 'pdp-thumb__label';
          text.setAttribute('aria-hidden', 'true');
          button.appendChild(text);
        }
        if (text.textContent !== label) text.textContent = label;
      });
      var active = rail.querySelector('.pdp-thumb[aria-pressed="true"]');
      if (active && active !== previous && window.matchMedia('(max-width:900px)').matches) {
        var box = active.getBoundingClientRect(), bounds = rail.getBoundingClientRect();
        if (box.left < bounds.left) rail.scrollLeft -= bounds.left - box.left + 4;
        else if (box.right > bounds.right) rail.scrollLeft += box.right - bounds.right + 4;
      }
      previous = active;
    }
    syncLabels();
    gallery.setAttribute('data-gallery-tabs-ready', '');
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; syncLabels(); });
    }).observe(rail, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['aria-pressed', 'hidden'] });

    var source = gallery.dataset.galleryArt;
    if (!source) return;
    var storageKey = 'affichely-gallery-tone-v4:' + source;
    try {
      var stored = sessionStorage.getItem(storageKey);
      if (stored && Object.keys(TONES).some(function (key) { return TONES[key] === stored; })) {
        gallery.style.setProperty('--pdp-beige', stored);
        return;
      }
    } catch (error) {}
    function sample() {
      var image = new Image();
      image.crossOrigin = 'anonymous';
      image.decoding = 'async';
      image.fetchPriority = 'low';
      image.onload = function () {
        try {
          var canvas = document.createElement('canvas');
          canvas.width = canvas.height = 32;
          var context = canvas.getContext('2d', { willReadFrequently: true });
          if (!context) return;
          context.drawImage(image, 0, 0, 32, 32);
          var tone = galleryTone(context.getImageData(0, 0, 32, 32).data);
          gallery.style.setProperty('--pdp-beige', tone);
          try { sessionStorage.setItem(storageKey, tone); } catch (error) {}
        } catch (error) {}
      };
      image.src = source;
    }
    function idle() {
      if (window.requestIdleCallback) window.requestIdleCallback(sample, { timeout: 1500 });
      else setTimeout(sample, 200);
    }
    if (document.readyState === 'complete') idle();
    else window.addEventListener('load', idle, { once: true });
  }

  function start(scope) {
    scope.querySelectorAll('.pdp-gallery[data-gallery-style="atelier"]').forEach(initialize);
  }
  start(document);
  document.addEventListener('shopify:section:load', function (event) { start(event.target); });
})();
